import { connect } from 'react-redux'
import { compose } from 'redux'
import withType from 'components/common/hoc/withType'
import { toggleCompareTray } from '../actions'
import { COMPARE_TRAY_MAX_ITEMS } from '../constants'
import { getCompareTrayItems, getCompareTrayShow } from '../selectors'
import { compareItems } from './actions'
import BOTTireComparePanel from './components/BOTTireComparePanel'

const COMPARE_THRESHOLD = 2

const mapStateToProps = state => {
  const trayItems = getCompareTrayItems(state)

  return {
    disableCompare: trayItems.length < COMPARE_THRESHOLD,
    items: [...trayItems, ...Array(COMPARE_TRAY_MAX_ITEMS - trayItems.length)],
    itemsCount: trayItems.length,
    compareTrayShow: getCompareTrayShow(state)
  }
}

export default compose(
  withType({ type: 'BOTTireComparePanel' }),
  connect(mapStateToProps, { toggleCompareTray, compareItems })
)(BOTTireComparePanel)
